import React from "react";
import { LoadingAnimation } from "@texada/ui";

const Loading = () => (
  <div className="loading_screen">
    <LoadingAnimation delay={100} />
  </div>
);

export const PageLoading = () => (
  <div className="loading_screen">
    <LoadingAnimation delay={100} />
  </div>
);

export default Loading;
